
import React from 'react';
import { ShieldCheck, ChevronRight, PlayCircle } from 'lucide-react';
import { Globe as InteractiveGlobe } from './interactive-globe';

export default function ModernHero({ onStartClick, onLearnMore }: { onStartClick: () => void, onLearnMore: () => void }) {
  return (
    <section className="bg-secondary py-12 sm:py-16 lg:py-24 relative overflow-hidden pt-36 md:pt-48 lg:pt-64 min-h-[600px]">
      {/* Ambient glow */}
      <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full bg-primary/10 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-96 h-96 rounded-full bg-primary/5 blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-6 sm:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-24">
          
          {/* Left content */}
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight md:leading-[0.9] mb-8 md:mb-10 tracking-tighter uppercase italic">
              A Inteligência <br className="hidden sm:block" />
              <span className="text-primary not-italic">por trás das</span> <br />
              Maiores Empresas.
            </h1>

            <p className="text-sm md:text-base text-white/60 mb-10 md:mb-12 max-w-md mx-auto lg:mx-0 font-medium leading-relaxed italic border-l-4 border-primary/40 pl-5 md:pl-8">
              O único Core Engine que une Radar GPRS, Auditoria Gemini IA e Controladoria de Lucro Real para locadoras de elite.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-12 md:mb-16">
               <button 
                onClick={onStartClick}
                className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-5 bg-primary text-white rounded-[20px] md:rounded-[24px] font-black uppercase text-[10px] md:text-xs tracking-[0.2em] shadow-2xl shadow-primary/40 hover:scale-105 transition-all flex items-center justify-center gap-3 group active:scale-95"
               >
                 Provisionar Agora <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform" />
               </button>
               <button 
                onClick={onLearnMore}
                className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-5 bg-white/5 border-2 border-white/10 text-white rounded-[20px] md:rounded-[24px] font-black uppercase text-[10px] md:text-xs tracking-[0.2em] hover:bg-white/10 transition-all flex items-center justify-center gap-3 active:scale-95"
               >
                 Documentação <PlayCircle size={18} className="text-primary" />
               </button>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-8 md:gap-12">
              <div>
                <p className="text-2xl md:text-3xl font-black text-white tracking-tighter italic">150+</p>
                <p className="text-[9px] font-black text-white/30 uppercase tracking-widest mt-1">Unidades SaaS</p>
              </div>
              <div className="w-px h-10 bg-white/10" />
              <div>
                <p className="text-2xl md:text-3xl font-black text-white tracking-tighter italic">&lt;50ms</p>
                <p className="text-[9px] font-black text-white/30 uppercase tracking-widest mt-1">Latência Core</p>
              </div>
              <div className="w-px h-10 bg-white/10" />
              <div>
                <p className="text-2xl md:text-3xl font-black text-white tracking-tighter italic">99.9%</p>
                <p className="text-[9px] font-black text-white/30 uppercase tracking-widest mt-1">Uptime Real</p>
              </div>
            </div>
          </div>

          {/* Right — Globe */}
          <div className="flex-1 flex items-center justify-center p-4 md:p-0 min-h-[400px] lg:min-h-[600px] relative">
            <div className="absolute inset-0 bg-primary/5 rounded-full blur-[100px] animate-pulse" />
            <InteractiveGlobe size={500} className="relative z-10" />
          </div>
        </div>

        {/* Verticals Trust indicators - Refined for mobile stacking */}
        <div className="mt-20 md:mt-32 pt-10 border-t border-white/5">
          <p className="text-center text-[8px] md:text-[9px] font-black text-white/20 uppercase tracking-[0.4em] md:tracking-[0.5em] mb-8 md:mb-10 italic">Segmentos Homologados no Core</p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-16 lg:gap-24 opacity-40 grayscale hover:grayscale-0 transition-all">
            {["Locação", "Construção", "Varejo", "HomeCare"].map((vertical, index) => (
              <div key={index} className="flex items-center space-x-2 group cursor-default">
                <div className="w-4 h-4 md:w-5 md:h-5 bg-white/5 rounded flex items-center justify-center group-hover:bg-primary transition-colors">
                   <ShieldCheck size={12} className="text-white/40 group-hover:text-white" />
                </div>
                <span className="text-white/40 font-black uppercase text-[9px] md:text-[10px] tracking-widest group-hover:text-white transition-colors">{vertical}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
